// // src/pages/Login.js
// import React, { useState } from "react";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { auth } from "../firebase-config";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       const userCredential = await signInWithEmailAndPassword(auth, email, password);
//       const idToken = await userCredential.user.getIdToken();

//       // Send ID token to backend
//       const response = await axios.get("http://localhost:8081/protected", {
//         headers: {
//           Authorization: `Bearer ${idToken}`,
//         },
//       });

//       console.log(response.data);
//       navigate("/dashboard");
//     } catch (error) {
//       console.error("Login error:", error);
//       alert("Authentication failed. Please check your credentials.");
//     }
//   };

//   return (
//     <div>
//       <h2>Login</h2>
//       <input
//         type="email"
//         placeholder="Email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//       /><br/>
//       <input
//         type="password"
//         placeholder="Password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//       /><br/>
//       <button onClick={handleLogin}>Login</button>
//     </div>
//   );
// };

// export default Login;


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// src/pages/Login.js
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase-config";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";



const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const idToken = await userCredential.user.getIdToken();

      // Send ID token to backend
      // await axios.get("http://localhost:8081/protected", {
      await axios.get(`${process.env.REACT_APP_API_BASE_URL}/protected`, {  
        headers: { Authorization: `Bearer ${idToken}` },
      });

      navigate("/dashboard", email);
    } catch (error) {
      console.error("Login error:", error);
      alert("Authentication failed. Please check your credentials.");
    }
  };


  const handleResetPassword = async () => {
    if (!email) {
      alert("Please enter your email above to reset your password.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent. Check your inbox.");
    } catch (error) {
      console.error("Password reset error:", error.code, error.message);
      alert(`Reset failed: ${error.message}`);
    }
  };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
        <h2 className="mb-6 text-center text-3xl font-extrabold text-gray-900">
          Sign in to your account
        </h2>
        <form className="space-y-6" onSubmit={handleLogin}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <button
            type="submit"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            Login
          </button>
          <p className="mt-4 text-center text-sm">
            <button
              onClick={handleResetPassword}
              className="text-indigo-600 hover:text-indigo-800"
            >
              Forgot Password?
            </button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;